import { Tooltip } from '../../../../components/tooltip/index';

export const renderLinkedEventValue = (linkedEventLabel: string) => {
  if (linkedEventLabel === '-') {
    return linkedEventLabel;
  }

  return (
    <Tooltip content={linkedEventLabel}>
      <div className="block max-w-full truncate">{linkedEventLabel}</div>
    </Tooltip>
  );
};
